<template>
  <div>

    <nav class="navbar customNavbar" >
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItemSelected" >Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <h2 class="title is-2">Productos</h2>
      <br/>
      <div class="columns">
        <div class="column"></div>
        <div class="column is-6">
          <div class="field has-addons">
            <p class="control is-expanded">
                <input v-model="nameSearch" :class="{'input': true, 'is-danger': errors.has('nameSearch') }" type="text" name="nameSearch" />
                <span v-show="errors.has('nameSearch')" class="help is-danger">{{ errors.first('nameSearch') }}</span>
            </p>
            <div class="control">
                <button class="button customButton" v-on:click="getProducts">Buscar</button>
                <button class="button customButton" v-on:click="cleanNameSearch" >Limpiar</button>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
      <div class="columns">
        <div class="column">
          <aside class="menu customMenu" >
            <ul class="menu-list">
              <li v-for="productType of productTypeList"><a class="menuLink customMenuItem" v-on:click="searchType(productType)" >{{productType}}</a></li>
              <li><a class="menuLink customMenuItem" v-on:click="cleanTypeSearch">Todos</a></li>
            </ul>
          </aside>
        </div>
        <div class="column is-10">
          <div style="max-height: 650px; min-height: 305px; overflow-y: scroll; overflow-x: hidden">
            <div class="tile is-ancestor" v-for="line of productList">
              <div class="tile is-parent" v-for="prodItem of line.products">
                <article class="tile is-child box">
                  <p class="title is-4" v-if="prodItem != null">{{prodItem.title}}</p>
                  <template v-if="prodItem.orientationH">
                    <img v-if="prodItem.firstImage != null" :src="multimediaBase+prodItem.firstImage" align="center" class="productImageH" />
                  </template>
                  <template v-else>
                    <img v-if="prodItem.firstImage != null" :src="multimediaBase+prodItem.firstImage" align="left" class="productImageV" />
                  </template>
                  <p class="productInfo" v-if="prodItem != null" style="text-align: right">{{prodItem.message}}</p>
                  <router-link v-if="prodItem != null" :to="{path: '/products/' + prodItem.id}" class="productLink">Más info</router-link>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <FooterComponent/>
  </div>
</template>

<script>
import ApiClient from '@/api/ApiClient.js'
import FooterComponent from './FooterComponent'

export default {
  name: 'landing',
  components: {
    FooterComponent
  },
  data () {
    return {
      isLogged: localStorage.getItem('email') !== null,
      productTypeList: [],
      productList: [],
      nameSearch: '',
      typeSearch: '',
      multimediaBase: '/multimedia/'
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    },
    getProducts () {
      ApiClient.products(this.nameSearch, this.typeSearch).then(response => {
        if (response.data.success) {
          this.productList = response.data.productLine
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    getTypes () {
      ApiClient.productTypes().then(response => {
        if (response.data.success) {
          this.productTypeList = response.data.productTypes
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    cleanNameSearch () {
      this.nameSearch = null
      this.getProducts()
    },
    cleanTypeSearch () {
      this.typeSearch = null
      this.getProducts()
    },
    getData () {
      this.getProducts()
      this.getTypes()
    },
    searchType (selectedType) {
      this.typeSearch = selectedType
      this.getProducts()
    }
  },
  created () {
    this.getData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 80px;
    width: 300px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .menuLink {
    text-align: left;
  }
  .productInfo {
    font-size: small;
    text-align: center;
  }
  .productLink {
    font-size: small;
    float:right
  }
  .productImageH {
    margin-bottom: 20px;
    align-content: center;
    height: 120px;
    width: 250px;
  }
  .productImageV {
    margin-left: 10px;
    margin-right: 30px;
    align-content: initial;
    height: 200px;
    width: 140px;
  }
</style>



// WEBPACK FOOTER //
// ProductsComponent.vue?6584b069